<dhcl-modal [show]="showModal" (closeClicked)="showModal = false;" [closeOnOverlay]="true">
  <div *ngFor="let modalDetail of modalDetails" [innerHTML]="decodeHtml(modalDetail)"></div>
</dhcl-modal>
